import React from 'react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  ChevronDown,
  X,
  Building2,
} from 'lucide-react';

interface BulkSelectionBarProps {
  selectedCount: number;
  onClear: () => void;
  onBulkUpdate: () => void;
}

export const BulkSelectionBar: React.FC<BulkSelectionBarProps> = ({
  selectedCount,
  onClear,
  onBulkUpdate,
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 animate-in slide-in-from-bottom-4 duration-300">
      <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-primary text-primary-foreground shadow-2xl text-sm whitespace-nowrap">
        <span className="flex h-5 w-5 items-center justify-center rounded-full bg-primary-foreground/25 text-xs font-bold">
          {selectedCount}
        </span>
        <span className="font-medium pr-1">
          {selectedCount === 1 ? 'resource' : 'resources'} selected
        </span>

        <div className="h-4 w-px bg-primary-foreground/30" />

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              size="sm"
              className="h-7 px-2.5 text-primary-foreground hover:bg-primary-foreground/20 hover:text-primary-foreground focus-visible:ring-primary-foreground/40 font-medium"
            >
              Actions
              <ChevronDown className="h-3 w-3 ml-1" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="center" side="top" className="w-52 mb-2">
            <DropdownMenuItem onClick={onBulkUpdate} className="gap-2">
              <Building2 className="h-4 w-4 text-muted-foreground" />
              Update Company Access
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={onClear} className="gap-2 text-muted-foreground">
              <X className="h-4 w-4" />
              Clear Selection
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>

        <div className="h-4 w-px bg-primary-foreground/30" />

        <button
          onClick={onClear}
          className="flex items-center gap-1 text-primary-foreground/80 hover:text-primary-foreground transition-colors px-1"
          aria-label="Clear selection"
        >
          <X className="h-3.5 w-3.5" />
          <span className="text-xs">Clear</span>
        </button>
      </div>
    </div>
  );
};
